// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/activity.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AdditionalInfo, TimelineItem } from "./timeline_pb";
import { file_pull_requests_v1_timeline } from "./timeline_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/activity.proto.
 */
export const file_pull_requests_v1_activity: GenFile = /*@__PURE__*/
  fileDesc("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", [file_pull_requests_v1_timeline]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/catch_up
 *
 * Defined by PullRequests::PageData::SharedController#catch_up.
 *
 * The legacy endpoint renders a JSON object with two keys: a categorized
 * `summary` and an ordered `timeline` list. `timeline` reuses the shared
 * TimelineItem message from timeline.proto so the two endpoints stay in
 * lockstep.
 *
 * @generated from message github.pull_requests.v1.ActivityResponse
 */
export type ActivityResponse = Message<"github.pull_requests.v1.ActivityResponse"> & {
  /**
   * Categorized rollup of catch-up events, consumed by the overview sidebar.
   *
   * @generated from field: github.pull_requests.v1.CatchUpTimelineSummary summary = 1;
   */
  summary?: CatchUpTimelineSummary;

  /**
   * Single ordered timeline, identical in shape to the GET .../timeline
   * endpoint. Wrapped here as a repeated field (the timeline endpoint wraps it
   * in TimelineResponse.items; this endpoint nests it under `timeline`).
   *
   * @generated from field: repeated github.pull_requests.v1.TimelineItem timeline = 2;
   */
  timeline: TimelineItem[];
};

/**
 * Describes the message github.pull_requests.v1.ActivityResponse.
 * Use `create(ActivityResponseSchema)` to create a new message.
 */
export const ActivityResponseSchema: GenMessage<ActivityResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_activity, 0);

/**
 * Categorized rollup of catch-up events. Each collection carries a
 * pre-computed `count` plus the matching events.
 *
 * @generated from message github.pull_requests.v1.CatchUpTimelineSummary
 */
export type CatchUpTimelineSummary = Message<"github.pull_requests.v1.CatchUpTimelineSummary"> & {
  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection approvals = 1;
   */
  approvals?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection changes_requested = 2;
   */
  changesRequested?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection comments = 3;
   */
  comments?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection review_comments = 4;
   */
  reviewComments?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection issue_comments = 5;
   */
  issueComments?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection commits = 6;
   */
  commits?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection closed = 7;
   */
  closed?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection reopened = 8;
   */
  reopened?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection marked_as_draft = 9;
   */
  markedAsDraft?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection ready_for_review = 10;
   */
  readyForReview?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection labeled = 11;
   */
  labeled?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection review_requested = 12;
   */
  reviewRequested?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection force_pushed = 13;
   */
  forcePushed?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection merged = 14;
   */
  merged?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection base_changed = 15;
   */
  baseChanged?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection base_change_failed = 16;
   */
  baseChangeFailed?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineEventCollection description_updated = 17;
   */
  descriptionUpdated?: CatchUpTimelineEventCollection;

  /**
   * @generated from field: int32 total = 18;
   */
  total: number;
};

/**
 * Describes the message github.pull_requests.v1.CatchUpTimelineSummary.
 * Use `create(CatchUpTimelineSummarySchema)` to create a new message.
 */
export const CatchUpTimelineSummarySchema: GenMessage<CatchUpTimelineSummary> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_activity, 1);

/**
 * @generated from message github.pull_requests.v1.CatchUpTimelineEventCollection
 */
export type CatchUpTimelineEventCollection = Message<"github.pull_requests.v1.CatchUpTimelineEventCollection"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;

  /**
   * @generated from field: repeated github.pull_requests.v1.CatchUpTimelineEvent events = 2;
   */
  events: CatchUpTimelineEvent[];
};

/**
 * Describes the message github.pull_requests.v1.CatchUpTimelineEventCollection.
 * Use `create(CatchUpTimelineEventCollectionSchema)` to create a new message.
 */
export const CatchUpTimelineEventCollectionSchema: GenMessage<CatchUpTimelineEventCollection> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_activity, 2);

/**
 * @generated from message github.pull_requests.v1.CatchUpTimelineEvent
 */
export type CatchUpTimelineEvent = Message<"github.pull_requests.v1.CatchUpTimelineEvent"> & {
  /**
   * ISO8601 timestamp.
   *
   * @generated from field: string timestamp = 1;
   */
  timestamp: string;

  /**
   * @generated from field: github.pull_requests.v1.CatchUpTimelineUser user = 2;
   */
  user?: CatchUpTimelineUser;

  /**
   * Per-event metadata. Catch-up summary events are the same underlying events
   * as the timeline (same loader, same `additional_info` hash), categorized
   * into buckets here, so they reuse the shared timeline AdditionalInfo oneof.
   * Absent (read as null by the client) when the event carries no metadata.
   *
   * @generated from field: github.pull_requests.v1.AdditionalInfo additional_info = 3;
   */
  additionalInfo?: AdditionalInfo;
};

/**
 * Describes the message github.pull_requests.v1.CatchUpTimelineEvent.
 * Use `create(CatchUpTimelineEventSchema)` to create a new message.
 */
export const CatchUpTimelineEventSchema: GenMessage<CatchUpTimelineEvent> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_activity, 3);

/**
 * @generated from message github.pull_requests.v1.CatchUpTimelineUser
 */
export type CatchUpTimelineUser = Message<"github.pull_requests.v1.CatchUpTimelineUser"> & {
  /**
   * User id. int64 (serialized as a JSON string) since user ids can exceed
   * 2^31; the client converts it back to a number.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.pull_requests.v1.CatchUpTimelineUser.
 * Use `create(CatchUpTimelineUserSchema)` to create a new message.
 */
export const CatchUpTimelineUserSchema: GenMessage<CatchUpTimelineUser> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_activity, 4);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ActivityResponseSchema, "288ce3a28ef8")
registerSchemaHash(CatchUpTimelineSummarySchema, "2bc2976670ef")
registerSchemaHash(CatchUpTimelineEventCollectionSchema, "9bb80611b275")
registerSchemaHash(CatchUpTimelineEventSchema, "c25126801f7a")
registerSchemaHash(CatchUpTimelineUserSchema, "edd72b795a48")
